import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { LoadingSpinnerProps } from '@typing/props';

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = undefined,
    className = '',
}) => (
    <Spinner animation="border" role="status" size={size} className={className}>
        <span className="visually-hidden">Loading...</span>
    </Spinner>
);

export default LoadingSpinner;
